<template>
  <div class="pg-obj">
    <div class="p-form-grid p-form-grid--3">
      <div class="p-field">
        <label class="p-field__label">Section Title</label>
        <input
          v-model="sectionData.content.sectionTitle"
          type="text"
          class="p-input"
          placeholder="섹션 제목"
        />
      </div>
      <div class="p-field">
        <label class="p-field__label">Title</label>
        <input
          v-model="sectionData.content.title"
          type="text"
          class="p-input"
          placeholder="문제 제목"
        />
      </div>
      <div class="p-field">
        <label class="p-field__label">Text</label>
        <input
          v-model="sectionData.content.text"
          type="text"
          class="p-input"
          placeholder="문제 설명"
        />
      </div>
    </div>

    <div class="pg-obj__options">
      <div
        v-for="(option, index) in sectionData.content.options"
        :key="index"
        class="pg-obj__item"
      >
        <div class="pg-obj__item-head">
          <span class="pg-obj__index">Option {{ index + 1 }}</span>
          <button
            type="button"
            class="pg-obj__icon-btn pg-obj__icon-btn--danger"
            title="제거"
            @click.prevent="removeOption(index)"
          >
            <i class="material-icons-round">delete</i>
          </button>
        </div>
        <div class="pg-obj__item-body">
          <div class="p-field">
            <label class="p-field__label">Option Text</label>
            <input
              v-model="option.option_text"
              type="text"
              class="p-input"
              placeholder="보기 텍스트"
            />
          </div>
          <div class="pg-obj__image">
            <label class="p-field__label">Option Image</label>
            <image-upload
              :default-image="option.option_image || require('@/assets/img/no_image.png')"
              :unique-id="'objective-option-image-' + index"
              v-model="option.option_image"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="pg-obj__actions">
      <ABtn kind="yellow" icon="add" @click.prevent="addOption">Option 추가</ABtn>
    </div>

    <div class="p-field pg-obj__answers">
      <label class="p-field__label">
        <i class="material-icons-round pg-obj__answers-ico">check_circle</i>
        Correct Answers
      </label>
      <multiple-select
        id="correctAnswers"
        v-model="sectionData.content.correctAnswer"
        :options="correctAnswerOptions"
        placeholder="정답을 선택하세요"
        :allow-search="true"
        :multiple="true"
      />
    </div>
  </div>
</template>

<script setup>
import { defineModel, computed } from "vue";
import ImageUpload from "@/components/ImageUpload.vue";
import MultipleSelect from "@/components/MultipleSelect.vue";
import ABtn from "@/components/Pineapple/ABtn.vue";

const sectionData = defineModel({ type: Object, required: true });

const correctAnswerOptions = computed(() =>
  sectionData.value.content.options.map((option, index) => ({
    value: option.option_text || `option-${index + 1}`,
    label: `Option ${index + 1}`,
  }))
);

const addOption = () => {
  sectionData.value.content.options.push({ option_text: "", option_image: "" });
};

const removeOption = (index) => {
  sectionData.value.content.options.splice(index, 1);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.pg-obj {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__options {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__item {
    background: $p-panel;
    border: 1px solid $p-line;
    border-radius: $p-radius-md;
    padding: 14px 16px;
    transition: border-color $p-dur $p-ease;

    &:hover { border-color: $p-line-hard; }
  }

  &__item-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px dashed $p-line;
  }

  &__index {
    padding: 4px 12px;
    border-radius: 999px;
    background: $p-ink;
    color: $p-point;
    font-family: $p-font-mono;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.04em;
  }

  &__icon-btn {
    width: 30px;
    height: 30px;
    border: 0;
    background: transparent;
    color: $p-ink-mid;
    border-radius: $p-radius-sm;
    display: grid;
    place-items: center;
    cursor: pointer;
    transition: background $p-dur $p-ease, color $p-dur $p-ease;

    > i { font-size: 16px; }

    &--danger {
      color: $p-err;
      &:hover { background: $p-err-soft; }
    }
  }

  &__item-body {
    display: grid;
    grid-template-columns: 1fr 200px;
    gap: 16px;
    align-items: start;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &__image {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__actions {
    display: flex;
    gap: 8px;
  }

  &__answers {
    margin-top: 8px;
  }

  &__answers-ico {
    font-size: 14px !important;
    color: $p-ok;
    vertical-align: middle;
    margin-right: 4px;
  }
}
</style>
